module.exports = __webpack_public_path__ + "media/images/flags/MP-18f4dc0fdac9fa758df59c0f228b8fec.svg";